import ApiService from "./axios/Apiservices";

export const getcategorylist = async () => {
    return ApiService.get("/categorilist");
};